import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import CommonFns from 'functions/common.ts';

function I8dReportList(props) {
  const Config = {
    purchase: {
      apiPath: '/verifyP8dReport/getPageList',
      enumMainKey: '',
      companyNameKey: 'innerVendorName',
      detailLink: '/mp/purchase/iqc/8d-report/detail',
      searchBarPlaceholder: '供应商编码/名称、物料编码/名称、影响客户/产品',
      tabs: ['全部', '待发出', '待改善', '待审核', '待结案'],
      countApi: '/verifyP8dReport/count',
      arrEnumField: [
        {
          mainKey: 'B02_Product8D_Report_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_P8d_Optimize',
          subKey: 'p8dOptimize',
          value: 'optStatusName'
        },
        {
          mainKey: 'B02_Product8D_Report_Bad_Type',
          subKey: 'badType',
          value: 'badTypeName'
        }
      ],
      countTransform: (data, self) => {
        let { 0: a, 1: b, 4: c, 2: d } = data;
        setCount([undefined, a, b, c, d]);
      },
      tabConfig: [
        undefined, //全部
        0, // 待发出
        1, //待改善
        4, //待审核
        2 //待结案
      ]
    },
    sale: {
      apiPath: '/customerVerifyP8d/getPageList',
      enumMainKey: '',
      companyNameKey: 'innerCustomerName',
      detailLink: '/mp/sale/customer/iqc/8d-report/detail',
      searchBarPlaceholder: '客户编码/名称、8D报告单号、物料编码/名称',
      tabs: ['全部', '待改善', '待结案'],
      countApi: '/customerVerifyP8d/count',
      arrEnumField: [
        {
          mainKey: 'B02_Product8D_Report_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_P8d_Optimize',
          subKey: 'p8dOptimize',
          value: 'optStatusName'
        },
        {
          mainKey: 'B02_Product8D_Report_Bad_Type',
          subKey: 'badType',
          value: 'badTypeName'
        }
      ],
      countTransform: (data, self) => {
        let { 1: a, 2: b } = data;
        setCount([undefined, a, b]);
      },
      tabConfig: [
        undefined, //全部
        1, // 待改善
        2 // 待结案
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  self.beforeSearch = async function () {
    self.searchQueries = {
      status: config.tabConfig[currentTab]
    };
  };

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
              {/* {searchKey && (
                <div className="searchKeyBox">
                  查询信息：
                  <div onClick={handleClear}>
                    <span className="singleOmission">{searchKey}</span>
                    <ClearIcon
                      className="verticalMiddle"
                      color="primary"
                      fontSize="inherit"
                    />
                  </div>
                </div>
              )} */}
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.p8dXkNo}`}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.p8dInnerNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass('d8Report', item.status)
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        {self.isPurchase && (
                          <li>
                            <label>供应商</label>
                            <div>
                              {item.innerVendorName}({item.innerVendorCode})
                            </div>
                          </li>
                        )}
                        {!self.isPurchase && (
                          <li>
                            <label>客户</label>
                            <div>
                              {item.innerCustomerName}({item.innerCustomerCode})
                            </div>
                          </li>
                        )}
                        <li>
                          <label>检验单号</label>
                          <div>{item.vfoInnerNo}</div>
                        </li>
                        <li>
                          <label>发布时间</label>
                          <div>
                            {formatDate(item.publishTime, 'YYYY-MM-DD HH:mm')}
                          </div>
                        </li>
                        <li>
                          <label>发布人</label>
                          <div>{item.publishName}</div>
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

I8dReportList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(I8dReportList);
